import axios from 'axios'
const EventBus = window.EventBus;

export const SpaVehicleCard = {
  props: ['vehicle', 'templatedir', 'lang','galleryinteraction', 'comingsoon', 'count'],
  data(){
        return {
          picture: this.vehicle.picture ? this.getFirstPicture(this.vehicle.picture) : this.vehicle.picture,
          pictureTs: this.vehicle.picture ? this.vehicle.picture.split('XXL').join('card.jpg').replace(/\?ts=.*/, '').replace("http:","https:") : this.vehicle.picture,
          pictureWebp: this.vehicle.picture ? this.getFirstPictureWebp(this.vehicle.picture) : this.vehicle.picture,
          pictureWebpTs: this.vehicle.picture ? this.vehicle.picture.split('XXL').join('card.webp').replace(/\?ts=.*/, '').replace("http:","https:") : this.vehicle.picture,
          secondPicture: this.getSecondPicture(this.vehicle.id),
          secondPictureWebp: this.getSecondPictureWebp(this.vehicle.id),
          allPictures: this.getAllPictures(this.vehicle.id)
        }
  },
  created(){
    if(this.comingsoon == true && this.vehicle.incoming == true)
      this.templatedir = this.templatedir.split('-photo').join('-photo-incoming');
    if(!this.picture)
      this.picture = this.templatedir;  
    if(!this.pictureTs)
      this.pictureTs = this.templatedir;
    if(!this.pictureWebpTs)
      this.pictureWebpTs = this.templatedir;
    if(!this.pictureWebp)
      this.pictureWebp = this.templatedir;
    if(!this.secondPicture)
      this.secondPicture = 0;
    if(!this.secondPictureWebp)
      this.secondPictureWebp = 0;
    if(!this.allPictures)
      this.allPictures =  0;
  },
  methods: {
    vehicleSlugPart(){
      var slug = this.vehicle.condition.toLowerCase().replace(/ /g, "-") + "-" +
      this.vehicle.year.toLowerCase().replace(/ /g, "-") + "-" +
      this.vehicle.make.toLowerCase().replace(/ /g, "-") + "-" +
      this.vehicle.model.toLowerCase().replace(/ /g, "-").replace('/', '') + "-" +
      this.vehicle.id;
      return slug;
    },
    trackEvent() {
      var data = this.vehicle.year + '-' + 
      this.vehicle.make + '-' + 
      this.vehicle.model + '-' + 
      this.vehicle.trim + '-' + 
      this.vehicle.stocknumber;

      var payload = {event_category: 'LBX-VDP', event_label: 'LBX-' + data};
      window.sendGAEvent('LBX-View-Click', payload);

    //  console.log('GTAG SENT LBX-View-Click' + data);
    },
    getFirstPicture(vehiclePicture){
      if(vehiclePicture && EventBus.checkValidCDN(vehiclePicture)){
          if(vehiclePicture.includes('XXL'))
            return vehiclePicture.split('XXL').join('card.jpg').replace("http:","https:");
          else if(vehiclePicture.includes('.png') || vehiclePicture.includes('invassets'))
            return vehiclePicture.replace("http:","https:");
          else
            return vehiclePicture.replace("http:","https:")+"-card.jpg";
      }
      else{
        return vehiclePicture.replace("http:","https:");
      }
    },
    getFirstPictureWebp(vehiclePicture){
      if(vehiclePicture && EventBus.checkValidCDN(vehiclePicture)){
        if(vehiclePicture.includes('XXL'))
          return vehiclePicture.split('XXL').join('card.webp').replace("http:","https:")
        else if(vehiclePicture.includes('.png') || vehiclePicture.includes('invassets'))
          return vehiclePicture.replace("http:","https:");
        else
          return vehiclePicture.replace("http:","https:")+"-card.webp";
      }
      else{
        return vehiclePicture.replace("http:","https:");
      }
    },
    getSecondPicture(vehicleId) {
        if(vehicleId && vehicleId != undefined && (this.galleryinteraction != '' && this.galleryinteraction == 'swap-photo') || window.location.origin.includes("yorkdalelincoln")){
        var finalUrl = "";

        var urlDetail = window.location.origin+"/wp-content/uploads/data/"+vehicleId+".json?v=" + EventBus.getJSONTimestamp(5,'Detail');
          axios.get(urlDetail)
          .then(({ data }) => {
            if(data.pictures && data.pictures.length > 0){
              finalUrl = data.pictures[1];

              if(finalUrl && EventBus.checkValidCDN(finalUrl)){
                if(finalUrl.includes('XXL'))
                  this.secondPicture = finalUrl.split('XXL').join('card.jpg').replace("http:","https:");
                else if(finalUrl.includes('.png') || finalUrl.includes('invassets') )
                  this.secondPicture =  finalUrl.replace("http:","https:");
                else
                  this.secondPicture = finalUrl.replace("http:","https:")+"-card.jpg";
              }
              else{
                this.secondPicture = finalUrl.replace("http:","https:");
              }
            } else {
              finalUrl = this.templatedir;
              this.secondPicture = finalUrl;
            }
        });
    }
    return null;
    },
    getSecondPictureWebp(vehicleId) {
      if(vehicleId && vehicleId != undefined && (this.galleryinteraction != '' && this.galleryinteraction == 'swap-photo')){
        var finalUrl = "";

        var urlDetail = window.location.origin+"/wp-content/uploads/data/"+vehicleId+".json?v=" + EventBus.getJSONTimestamp(5,'Detail');
          axios.get(urlDetail)
          .then(({ data }) => {
            if(data.pictures && data.pictures.length > 0){
              finalUrl = data.pictures[1];

              if(finalUrl && EventBus.checkValidCDN(finalUrl)){
                if(finalUrl.includes('XXL'))
                  this.secondPictureWebp = finalUrl.split('XXL').join('card.jpg').replace("http:","https:");
                else if(finalUrl.includes('.png') || finalUrl.includes('invassets') )
                  this.secondPictureWebp =  finalUrl.replace("http:","https:");
                else
                  this.secondPictureWebp = finalUrl.replace("http:","https:")+"-card.webp";
              }
              else{
                this.secondPictureWebp = finalUrl.replace("http:","https:");
              }
            }
        });
    }
    return null;
    },
    getAllPictures(vehicleId) {
      if(vehicleId && vehicleId != undefined  && (this.galleryinteraction != '' && this.galleryinteraction == 'mini-gallery')  ){
        var urlDetail = window.location.origin+"/wp-content/uploads/data/"+vehicleId+".json?v=" + EventBus.getJSONTimestamp(5,'Detail');

          axios.get(urlDetail)
          .then(({ data }) => {
            if(data.pictures && data.pictures.length > 0){
              for(var i= 0; i < data.pictures.length; i++){
                if(data.pictures[i] && EventBus.checkValidCDN(data.pictures[i])){
                  if(data.pictures[i].includes('XXL'))
                    data.pictures[i] = data.pictures[i].split('XXL').join('card.jpg').replace("http:","https:");
                  else if(data.pictures[i].includes('.png') || data.pictures[i].includes('invassets') )
                    data.pictures[i] =  data.pictures[i].replace("http:","https:");
                  else
                    data.pictures[i] = data.pictures[i].replace("http:","https:")+"-card.jpg";
                }
                else{
                  data.pictures[i] = data.pictures[i].replace("http:","https:");
                }
              }

              setTimeout(() => {
                      if(!data.trim)
                        var dtrim = "";
                      else
                        var dtrim = data.trim.split(' ').join('-');

                      jQuery(".slick-gallery-"+vehicleId).not(".slick-initialized").slick({dots:!0,
                        nextArrow: "<button data-vehicle='"+data.condition+'-'+data.year+'-'+data.make+'-'+data.model.split(' ').join('-')+'-'+dtrim+'-'+data.stocknumber+"' class='slick-next slick-arrow' aria-label='Next' type='button'>Next</button>",
                        infinite:!0,speed:500,slidesToShow:1,slidesToScroll:1,responsive:[{breakpoint:1279,settings:{slidesToShow:1,slidesToScroll:1,infinite:!0,dots:!0}},{breakpoint:600,settings:{slidesToShow:1,slidesToScroll:1,infinite:!0,dots:!0}}]});
              },100);
              var allp = data.pictures.slice(0,11);
              this.allPictures = allp;
            } else
                this.allPictures = [this.templatedir];
            
            setTimeout(() => {
                var lazyImages = [].slice.call(document.querySelectorAll(".vehicle-card .main-img"));
                    if (!('IntersectionObserver' in window) ||
                    !('IntersectionObserverEntry' in window) ||
                    !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
                        lazyImages.forEach(img => {
                            img.src = img.dataset.src;
                        });
                    }else{
                        let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
                            entries.forEach(function(entry) {
                                if (entry.isIntersecting) {
                                    let lazyImage = entry.target;
                                    lazyImage.src = lazyImage.dataset.src;
                                    lazyImageObserver.unobserve(lazyImage);
                                }
                            });
                        });
                    
                        lazyImages.forEach(function(lazyImage) {
                        lazyImageObserver.observe(lazyImage);
                        });
                    }
             },100);

          })
      }
    },
    trackEventForm(formType) {
      var payload = {event_category: 'LBX-Form', event_label: 'LBX-Form-' + formType};
      window.sendGAEvent('LBX-View', payload);

      console.log('GTAG SENT LBX-View-Form-Click');
    },
    imgLoadOnError(id) {
        if(id){
            for (let i = 0; i < this.$refs[id+"vc-main-img"].length; i++) {
                this.$refs[id+"vc-main-img"][i].src = this.templatedir;
            }
        }
        this.picture = this.templatedir;
    },
    FloorPlanLoadOnError(id) {
      if(this.$refs[id][0] && this.$refs[id][0].parentNode.parentNode) {
        this.$refs[id][0].parentNode.parentNode.remove();
      }
    },
    imgMiniGalleryLoadOnError(index, prefixLabel) {
      let prefix = (prefixLabel) ? prefixLabel : "mini_img_";
      this.$refs[prefix + index][0].src = this.templatedir;

      if(this.$refs[prefix + index] && this.$refs[prefix + index][0] && this.$refs[prefix + index][0].parentNode && this.$refs[prefix + index][0].parentNode.children){
        for (let i = 0; i < this.$refs[prefix + index][0].parentNode.children.length; i++) {
          this.$refs[prefix + index][0].parentNode.children[i].srcset = this.templatedir;
          
          if(this.$refs[prefix + index][0].parentNode.children[i].src){
            this.$refs[prefix + index][0].parentNode.children[i].src = this.templatedir;
          }
          if(this.$refs[prefix + index][0].parentNode.children[i].getAttribute('data-src')){
            this.$refs[prefix + index][0].parentNode.children[i].setAttribute("data-src", this.templatedir);
          }
        }
      }
    },
    imgLoadOnErrorSecondPicture() {
      this.secondPicture = this.templatedir;
    },
    goToCompare(id) {
      EventBus.$emit('goToCompare', id, this.lang);
    },
    isMoreThan(value1, value2) {
      return value1 > value2
    },
    isMoreOrEqualThan(value1, value2) {
      return value1 >= value2
    },
    isLessOrEqualThan(value1, value2) {
      return value1 <= value2
    },
    isLessThan(value1, value2) {
      return value1 < value2
    },
    sumValue(value1, value2) {
      return value1 + value2
    },
    subtractValue(value1, value2) {
      return value1 - value2
    },
    getWeeksDiff(startDate, endDate) {
      const msInWeek = 604800;
      var fstartDate = new Date(new Date().toLocaleString('en', { timeZone: 'America/Toronto' })) / 1000;

      return Math.ceil((endDate - fstartDate) / msInWeek);
    }
  },
  computed: {
    vehicleTitle(){
      if(this.lang == 'fr-CA')
        return (this.vehicle.condition ? `${this.vehicle.condition} ` : "") +
          (this.vehicle.make ? `${this.vehicle.make} ` : "") +
          (this.vehicle.model ? `${this.vehicle.model} ` : "") +
          (this.vehicle.year ? `${this.vehicle.year} ` : "") +
          (this.vehicle.trim ? `${this.vehicle.trim} ` : "") +
          (this.vehicle.stocknumber ? `${this.vehicle.stocknumber}` : "");
      else
        return (this.vehicle.condition ? `${this.vehicle.condition} ` : "") +
          (this.vehicle.year ? `${this.vehicle.year} ` : "") +
          (this.vehicle.make ? `${this.vehicle.make} ` : "") +
          (this.vehicle.model ? `${this.vehicle.model} ` : "") +
          (this.vehicle.trim ? `${this.vehicle.trim} ` : "") +
          (this.vehicle.stocknumber ? `${this.vehicle.stocknumber}` : "");
    },
    viewSlug(){
      let slug = "/view/";
      if(this.lang == 'fr-CA')
        slug = "/vue/";

      return slug + this.vehicleSlugPart() + "/"
    },
    discount(){
      let result = this.vehicle.saleprice - this.vehicle.price;
      return ((result > 0 ) ? result : 0);
    },
    showMSRP(){
      let result = (this.vehicle.saleprice && this.vehicle.saleprice > 0 && this.vehicle.saleprice > this.vehicle.price);
      return result;
    },
    extendedDiscounts(){
      let result = this.vehicle.saleprice - this.vehicle.extendedprice;
      return ((result > 0 ) ? result : 0);
    },
  },
  filters: {
    moneyFormat:(price, lang)=>{
      var formatter = new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: 0,
      });
      return formatter.format(Math.floor(price));
    },
    replaceLiter:(string)=>{
      if(string)
        return string.replace("Liter","L").replace("liter","L").replace("litre","L").replace("Litre","L");
      else
        return "-";

    },
    stringReplace:(value, search, rep)=>{
      let replacement = '';
      if (typeof rep !== 'undefined' && !rep) { 
        replacement = rep;
      } 

      if (typeof value === 'undefined' || value === null) 
        return "";
      else
        return value.replace(search,replacement);
    }
  }
}